'use client';

import { cx } from '@endurancewarranty/ui';

import type { FC, ReactNode } from 'react';

export type TBaseLayoutProps = Readonly<{
  className?: string;
  children: ReactNode;
  width?: 'fixed' | 'full';
}>;

export const BaseLayout: FC<TBaseLayoutProps> = ({ className, children, width = 'fixed' }) => {
  const layoutStyle = cx(
    {
      'mx-auto max-w-[800px]': width === 'fixed',
      'w-full': width === 'full',
    },
    'pb-12',
    className,
  );

  return <div className={layoutStyle}>{children}</div>;
};
